<template>
  <MLabel
    class="flex grow"
    :class="{ 'relative cursor-pointer hover:underline': promotion }"
    type="promo"
  >
    <div>
      <slot>
        <span
          v-if="promotion"
          :id="promotion.id"
          v-html="$t(`promotions:${promotion.headline}`, promoVariables)"
        />
      </slot>
      <span v-if="promotion" class="hidden lg:inline underline">
        {{ $t('details') }}
      </span>
    </div>
    <button v-if="promotion" class="block absolute inset-0" @click="open" />
    <MModal v-if="promotion && modalOpen" @close="modalOpen = false" modal-class="md:max-w-lg">
      <PromotionModal
        :promotion="promotion"
        :provider-logo="providerLogo"
        :provider-display-name="providerDisplayName"
      >
        <template #link>
          <slot name="link" />
        </template>
      </PromotionModal>
    </MModal>
  </MLabel>
</template>

<script lang="ts" setup>
import PromotionModal from './promotion-modal.vue'
import type { Promotion } from './types'
import { getPromotionVariables } from './helpers/utils'

const props = defineProps<{
  providerLogo: string
  providerDisplayName: string
  promotion?: Promotion
}>()

const emit = defineEmits(['open'])

const modalOpen = ref(false)

function open() {
  modalOpen.value = true
  emit('open')
}

const promoVariables = computed(() => {
  return getPromotionVariables(props.promotion, props.providerDisplayName)
})
</script>
